export enum ABTestID {
  PLG = '50_percent_traffic_widget_display',
  LIVE_HELPER_IDLE_VARIANT = 'live_helper_idle_expanded_1',
  AVA_IN_PLAYER_ANSWER_ACTION = 'ava_in_player_answer_action',
  NINETY_FIVE_PERCENT_TRAFFIC_WIDGET_DISPLAY = '95_percent_traffic_widget_display',
}
export interface ABTestBucket {
  id: string
  weight: number
  min?: number
  max?: number
  guestBucket?: boolean
}
export interface ABTest {
  id: ABTestID
  buckets: ABTestBucket[]
}

export type AllTests = Map<string, ABTest>

export interface TrackingTest {
  id: ABTestID
  variant: string | undefined
}
